export const csrfCookieName = 'CSRF_TOKEN'

export const SMS_CODE__LENGTH = 6
export const SMS_CODE__ATTEMPTS_COUNT = 10

export const WIDGET_STEP__SELECT_SPEC_OR_DOCTOR = 100
export const WIDGET_STEP__SELECT_DOCTOR = 200
export const WIDGET_STEP__SELECT_FILIAL = 300
export const WIDGET_STEP__SELECT_SERVICE = 400
export const WIDGET_STEP__SELECT_SCHEDULE = 500
export const WIDGET_STEP__PATIENT_DATA = 600
export const WIDGET_STEP__CONFIRM_PHONE = 700
export const WIDGET_STEP__FINAL = 800

//Список дней в именительном падеже
export const weekdaysList = [
  'понедельник',
  'вторник',
  'среда',
  'четверг',
  'пятница',
  'суббота',
  'воскресенье'
]

//Список месяцев в родительном падеже
export const monthGenitiveList = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря'
]

export const genderList = [
  {value: 'MALE', text: 'Мужской'},
  {value: 'FEMALE', text: 'Женский'},
  {value: 'UNDEFINED', text: 'Не определён'},
]

/**
 * Внедрение констант со ссылкой до бэкенда в экземпляр Vue-приложения
 *
 * @param prototype экземпляр приложения
 */
export function injectBaseURLsToPrototype(prototype) {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    prototype.$backendLink = 'http://localhost:9000'
  } else {
    prototype.$backendLink = process.env.VUE_APP_API_ROOT || '/backend-booking'
  }
}